// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"ButtonLink_buttonWrapper__H6jZq","button":"ButtonLink_button__WgSLh","small":"ButtonLink_small__GOi1P","large":"ButtonLink_large__upvX5"};